import React, { useEffect, useRef, useState } from 'react';
import { Button, Col, Container, Row, Spinner } from 'react-bootstrap';
import rpsIcon from '../../assets/icon/rpsIcon.svg';
import policyIcon from '../../assets/icon/policyIcon.svg';
import auditIcon from '../../assets/icon/auditIcon.svg';
import biasIcon from '../../assets/icon/biasIcon.svg';
import unsafeIcon from '../../assets/icon/unsafeIcon.svg';
import fairnessIcon from '../../assets/icon/fairnessIcon.svg';
import piiIcon from '../../assets/icon/piiIcon.svg';
import ComplianceEthicsIcon from '../../assets/icon/ComplianceEthicsIcon.svg';
import filterIcon from '../../assets/icon/filterIcon.svg';
import calenderIcon from '../../assets/icon/calenderIcon.svg';
import { ReactComponent as ExportIcon } from '../../assets/icon/Export.svg';
import MetricCard from '../../components/SystemAnalytics/MetricCard';
import DonutChart from '../../components/AnalyticsChart/DonutChart';
import FilterForm from '../../components/SystemAnalytics/FilterForm';
import { useAzureData } from '../../context/AzureContext';
import {
  ethicsAnalyticsCardsData,
  filterDropdownData
  // filterDropdownDataCloudProvider
} from '../../service/apiServices';
import BarChart from '../../components/AnalyticsChart/BarChart';
import { ToolTipFunction } from '../../components/inputField';
import { Info } from 'lucide-react';
import useCloudProvider from '../../hooks/useCloudProvider';
import UnileverAnimation from '../../components/UnileverAnimation';
import { analyticsSheetBuilders, exportAnalyticsReport } from '../../utilities/analyticsExport';

const getDefaultDateRange = () => {
  const today = new Date();
  const pastDate = new Date();
  pastDate.setDate(today.getDate() - 6); // 7 days before today
  return { fromDate: pastDate, toDate: today };
};

const truncateText = (text: string, maxLength = 30) => {
  if (!text) return '';
  return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
};

interface CardsData {
  metricsData: {
    title: string;
    value: string;
    subtitle: string;
  }[];
}

interface DropdownValues {
  filters: {
    applications: string[];
    environments: string[];
    model_names: string[];
  };
}

const Ethics_ComplainceAnalytics = () => {
  const { apiToken } = useAzureData();
  const [show, setShow] = useState(false);
  const { fromDate, toDate } = getDefaultDateRange();
  const [dateRange, setDateRange] = useState({
    from: fromDate?.toLocaleDateString('en-GB'),
    to: toDate?.toLocaleDateString('en-GB')
  });
  const [choosedFilter, setChoosedFilter] = useState<any>('');
  const [currentchooseApp, setCurrentChoosedApp] = useState<any>('');

  const [ethicsAnalyticData, setEthicsAnalyticData] = useState<any>(null);
  const [cardsData, setCardsData] = useState<CardsData | null>(null);
  const [filterDropdownValues, setFilterDropdownvalues] = useState<DropdownValues | null>(null);
  const [cardLoading, setCardLoading] = useState(false);
  const [dropdownValuesLoading, setDropdownValuesLoading] = useState(false);
  const hasFetchedRef = useRef(false);
  const { selectedCloud, cloudProvidersList, selectCloud } = useCloudProvider();
  const [cloudFilterID, setCloudFilter] = useState(0);
  const selectedCloudName =
    cloudProvidersList.find((item) => item.id === selectedCloud)?.name || 'All Cloud Providers';

  const fetchCardData = async (appliedFilters: any) => {
    setCardLoading(true);
    try {
      let response = await ethicsAnalyticsCardsData(apiToken, appliedFilters);
      response && setCardsData(response);
      response && setEthicsAnalyticData(response);
      setCardLoading(false);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setCardLoading(false);
    }
  };

  const fetchDropdownData = async () => {
    setDropdownValuesLoading(true);
    try {
      let response = await filterDropdownData(
        apiToken,
        currentchooseApp ? currentchooseApp : '',
        cloudFilterID ? cloudFilterID : 0
      );
      response && setFilterDropdownvalues(response);
      setDropdownValuesLoading(false);
    } catch (error) {
      setDropdownValuesLoading(false);
      console.error('Error:', error);
    }
  };

  useEffect(() => {
    fetchDropdownData();
  }, [cloudFilterID]);

  useEffect(() => {
    if (hasFetchedRef?.current) return;
    hasFetchedRef.current = true;
    fetchCardData({});
    fetchDropdownData();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchDropdownData();
    //eslint-disable-next-line
  }, [currentchooseApp]);

  const metricsData = [
    {
      title: cardsData && cardsData?.metricsData[0]?.title,
      value: cardsData && cardsData?.metricsData[0]?.value,
      subtitle: cardsData && cardsData?.metricsData[0]?.subtitle,
      icon: rpsIcon
    },
    {
      title: cardsData && cardsData?.metricsData[1]?.title,
      value: cardsData && cardsData?.metricsData[1]?.value,
      subtitle: cardsData && cardsData?.metricsData[1]?.subtitle,
      icon: policyIcon
    },
    {
      title: cardsData && cardsData?.metricsData[2]?.title,
      value: cardsData && cardsData?.metricsData[2]?.value,
      subtitle: cardsData && cardsData?.metricsData[2]?.subtitle,
      icon: auditIcon
    },
    {
      title: cardsData && cardsData?.metricsData[3]?.title,
      value: cardsData && cardsData?.metricsData[3]?.value,
      subtitle: cardsData && cardsData?.metricsData[3]?.subtitle,
      icon: biasIcon
    },
    {
      title: cardsData && cardsData?.metricsData[4]?.title,
      value: cardsData && cardsData?.metricsData[4]?.value,
      subtitle: cardsData && cardsData?.metricsData[4]?.subtitle,
      icon: auditIcon
    },
    {
      title: cardsData && cardsData?.metricsData[5]?.title,
      value: cardsData && cardsData?.metricsData[5]?.value,
      subtitle: cardsData && cardsData?.metricsData[5]?.subtitle,
      icon: unsafeIcon
    },
    {
      title: cardsData && cardsData?.metricsData[6]?.title,
      value: cardsData && cardsData?.metricsData[6]?.value,
      subtitle: cardsData && cardsData?.metricsData[6]?.subtitle,
      icon: fairnessIcon
    },
    {
      title: cardsData && cardsData?.metricsData[7]?.title,
      value: cardsData && cardsData?.metricsData[7]?.value,
      subtitle: cardsData && cardsData?.metricsData[7]?.subtitle,
      icon: piiIcon
    }
  ];

  let applicationNames =
    filterDropdownValues &&
    filterDropdownValues?.filters?.applications?.length > 0 &&
    filterDropdownValues?.filters?.applications?.map((item) => ({ label: item, value: item }));
  let modelNames =
    filterDropdownValues &&
    filterDropdownValues?.filters?.model_names?.length > 0 &&
    filterDropdownValues?.filters?.model_names?.map((item) => ({ label: item, value: item }));

  useEffect(() => {
    if (
      !ethicsAnalyticData?.ContentSafetyDistribution &&
      !ethicsAnalyticData?.CustomParameterChartData
    ) {
      function formatDate(date) {
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const yyyy = date.getFullYear();
        return `${dd}/${mm}/${yyyy}`;
      }
      const today = new Date();
      const lastMonth = new Date();
      lastMonth.setMonth(today.getMonth() - 1);
      const dateRange = {
        from: formatDate(lastMonth),
        to: formatDate(today)
      };
      setDateRange(dateRange);
      const filters = {
        timePeriod: dateRange,
        application: '',
        modelName: ''
      };
      fetchCardData(filters);
      setChoosedFilter(filters);
    }
  }, [ethicsAnalyticData?.ContentSafetyDistribution, ethicsAnalyticData?.CustomParameterChartData]);

  const handleExport = () => {
    exportAnalyticsReport({
      fileName: `ethics_compliance_${choosedFilter?.application || 'all_apps'}_${
        choosedFilter?.modelName || 'all_models'
      }`,
      sheets: [
        {
          name: 'Filters',
          rows: [
            { Field: 'Application', Value: choosedFilter?.application || 'All Applications' },
            { Field: 'Model', Value: choosedFilter?.modelName || 'All Models' },
            { Field: 'Cloud Provider', Value: selectedCloudName },
            { Field: 'Date From', Value: choosedFilter?.timePeriod?.from || dateRange.from },
            { Field: 'Date To', Value: choosedFilter?.timePeriod?.to || dateRange.to }
          ]
        },
        {
          name: 'KPI Cards',
          rows: metricsData?.map((metric) => ({
            Title: metric.title,
            Value: metric.value,
            Subtitle: metric.subtitle
          }))
        },
        {
          name: 'PII Distribution',
          rows: analyticsSheetBuilders.toSeriesRows(ethicsAnalyticData?.PiiDetectionDistribution)
        },
        {
          name: 'Custom Parameters',
          rows: analyticsSheetBuilders.toSeriesRows(ethicsAnalyticData?.CustomParameterChartData)
        },
        {
          name: 'Harmful Output',
          rows: analyticsSheetBuilders.toSeriesRows(ethicsAnalyticData?.ContentSafetyDistribution)
        }
      ].filter((sheet) => sheet.rows && sheet.rows.length > 0)
    });
  };

  return (
    <>
      <Container fluid className="p-4 systemAnalytics_container">
        {/* Header */}
        <div className="mb-2">
          <Row className="justify-content-between align-items-start">
            <Col>
              <h2 className="analytics_heading m-0">
                <img src={ComplianceEthicsIcon} alt="analytics" /> Ethics & Compliance Analytics
              </h2>
              <p className="analytics_subheading">
                Track compliance, ethical risks, content safety, and governance across AI systems.
              </p>
            </Col>
          </Row>
        </div>

        {cardLoading ? (
          <div className="d-flex justify-content-center" style={{ marginTop: '10%' }}>
            {/* <Spinner animation="border" variant="primary" /> */}
            <UnileverAnimation />
          </div>
        ) : (
          <>
            {/* Filter section */}
            <Row className="d-flex mb-4">
              <Col className="d-flex align-align-items-center">
                <div className="d-flex align-items-center show_date_btn me-2">
                  {truncateText(choosedFilter?.application) || 'All Applications'}
                </div>
                <div className="d-flex align-items-center show_date_btn me-2">
                  {truncateText(choosedFilter?.modelName) || 'All Models'}
                </div>
                {
                  <div className="d-flex align-items-center show_date_btn me-2">
                    {['Azure', 'GCP']?.[cloudFilterID - 1] || 'GCP and Azure'}
                  </div>
                }
                {choosedFilter && (
                  <div className="d-flex align-items-center gap-2 show_date_btn">
                    <img src={calenderIcon} alt="calender" />
                    {dateRange.from} - {dateRange.to}
                  </div>
                )}
              </Col>
              <Col className="d-flex justify-content-end">
                <ToolTipFunction
                  toolTipText={
                    <>
                      <p>
                        <b>Unless a filter is applied, the data shown will be as follows:</b>
                      </p>
                      <ul>
                        <li>
                          <b>Cards</b> - Cumulative data up to the current date
                        </li>
                        <li>
                          <b>Graphs</b> - Data from the last 7 days
                        </li>
                      </ul>
                    </>
                  }>
                  <Info />
                </ToolTipFunction>
                <Button
                  onClick={() => setShow(true)}
                  variant="outline-secondary"
                  className="d-flex align-items-center ms-2 gap-2 filterBtn">
                  <img src={filterIcon} alt="filter" />
                  Filter
                </Button>
                <Button
                  onClick={handleExport}
                  variant="outline-secondary"
                  className="d-flex align-items-center ms-2 gap-2 filterBtn"
                  disabled={cardLoading || !ethicsAnalyticData}>
                  <ExportIcon width={16} height={16} />
                  Export
                </Button>
              </Col>
            </Row>

            {/* Metrics Cards */}
            <Row className="g-3 d-flex flex-wrap mb-4">
              {metricsData.map((metric, index) => (
                <Col className="" style={{ minWidth: '377px' }} key={index}>
                  <MetricCard
                    title={metric.title}
                    value={metric.value}
                    subtitle={metric.subtitle}
                    icon={metric.icon}
                  />
                </Col>
              ))}
            </Row>

            <Row className="mb-4" style={{ width: '250px' }}>
              <Col>
                <div className="d-flex align-items-center gap-2 show_date_btn">
                  <img src={calenderIcon} alt="calender" />
                  {dateRange.from} - {dateRange.to}
                </div>
              </Col>
            </Row>

            {/* Charts Row 1 */}
            <Row className="g-4 mb-4">
              <Col xs={12} lg={6}>
                {/*  @ts-ignore */}
                <DonutChart
                  DonutChartData={
                    ethicsAnalyticData && ethicsAnalyticData?.PiiDetectionDistribution
                  }
                  title="PII Detection Distribution Over Categories"
                  subtitle="Split of each PII type detected across all Applications."
                />
              </Col>
              <Col xs={12} lg={6}>
                {/* @ts-ignore */}
                <BarChart
                  BarChartData={ethicsAnalyticData && ethicsAnalyticData?.CustomParameterChartData}
                />
              </Col>
            </Row>

            {/* Charts Row 2 */}
            <Row className="g-4 mb-4">
              <Col xs={12} lg={6}>
                {/*  @ts-ignore */}
                <DonutChart
                  DonutChartData={
                    ethicsAnalyticData && ethicsAnalyticData?.ContentSafetyDistribution
                  }
                  title="Harmful Output Type Breakdown"
                  subtitle="Distribution of harmful categories detected in AI outputs"
                />
              </Col>
              <Col xs={12} lg={6}>
                {/*  @ts-ignore */}
                {/* <DonutChart DonutChartData={ethicsAnalyticsData && ethicsAnalyticsData?.PromptFailureChartData} title="Prompt Failure Type Distribution" subtitle="Displays the breakdown of error causes for failed prompts" /> */}
              </Col>
            </Row>
          </>
        )}
      </Container>

      <FilterForm
        show={show}
        onClose={() => setShow(false)}
        onApply={(filters) => {
          // fetchGraphData(filters)
          fetchCardData(filters);
          setChoosedFilter(filters);
          setCloudFilter(selectedCloud);
        }}
        onDateRangeChange={setDateRange}
        onCurrentChoosedAppChange={setCurrentChoosedApp}
        showCloudProvider={true}
        selectedCloud={selectedCloud}
        cloudProvidersList={cloudProvidersList}
        selectCloud={selectCloud}
        dropdownValuesLoading={dropdownValuesLoading}
        fields={[
          { key: 'timePeriod', label: 'Time Period', type: 'dateRange' },
          {
            key: 'application',
            label: 'Application',
            type: 'select',
            options: applicationNames ? applicationNames : []
          },
          {
            key: 'modelName',
            label: 'Model Name',
            type: 'select',
            options: modelNames ? modelNames : []
          }
        ]}
      />
    </>
  );
};

export default Ethics_ComplainceAnalytics;
